import { useEffect } from 'react';
import IdleDialog from 'components/Dialogs/IdleDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeIsScreenCanBeActive,
  setAutoLogoutDialogOpen,
  getUser,
  logout,
  navigateToRoute,
} from '../../../redux_store';
import { ALL_ROUTES } from '../../../config/routes';

const LOGOUT_TIMEOUT = 1000 * 60; //ms / s / m / h

let timeoutID;

const Idle = () => {
  const {
    authorizationExpiresTimeout,
    isTabActive,
    isAutoLogoutDialogOpen: isDialogOpen,
  } = useSelector(state => state.appSettings);
  const { isLogin } = useSelector(state => state.user);
  const dispatch = useDispatch();

  const onStayLogin = () => {
    isLogin && dispatch(getUser());
    dispatch(setAutoLogoutDialogOpen(false));
  };

  const handleLogout = text => {
    const _isLogin = isLogin;
    dispatch(logout());
    if (_isLogin) {
      window.location.href = `/login${text ?? ''}`;
    }
    dispatch(setAutoLogoutDialogOpen(false));
  };

  const logoutIfNeed = async () => {
    if (isLogin) {
      const timeNow = Date.now();
      const diff =
        (authorizationExpiresTimeout
          ? authorizationExpiresTimeout
          : localStorage.getItem('authorizationExpiresTimeout') &&
            localStorage.getItem('authorizationExpiresTimeout')) - timeNow;

      if (diff < 0) {
        clearTimeout(timeoutID);
        handleLogout('#auto_logout');
      } else if (diff <= LOGOUT_TIMEOUT) {
        if (!isDialogOpen) {
          clearTimeout(timeoutID);
          dispatch(setAutoLogoutDialogOpen(true));
        }
      } else {
        dispatch(changeIsScreenCanBeActive(true));
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
          if (localStorage.getItem('isLogin')) {
            dispatch(setAutoLogoutDialogOpen(true));
          }
        }, authorizationExpiresTimeout - timeNow - LOGOUT_TIMEOUT);
      }
    } else {
      dispatch(changeIsScreenCanBeActive(true));
    }
  };

  useEffect(() => {
    if (isTabActive) {
      logoutIfNeed();
    } else {
      dispatch(changeIsScreenCanBeActive(false));
    }
  }, [isTabActive]);

  useEffect(() => {
    if (!isLogin) {
      dispatch(changeIsScreenCanBeActive(true));
      clearTimeout(timeoutID);
    } else {
      if (authorizationExpiresTimeout) {
        logoutIfNeed();
      }
    }
  }, [isLogin]);

  useEffect(() => {
    if (authorizationExpiresTimeout) {
      logoutIfNeed();
    }
  }, [authorizationExpiresTimeout]);

  return (
    <IdleDialog
      open={isDialogOpen && isLogin}
      logout={() => {
        dispatch(setAutoLogoutDialogOpen(false));
        dispatch(
          navigateToRoute({
            route: {
              path: ALL_ROUTES.login.path,
            },
          })
        ).then(() => {
          dispatch(logout());
        });
      }}
      onClose={onStayLogin}
      onLogout={handleLogout}
      logoutTimeout={LOGOUT_TIMEOUT / 1000}
    />
  );
};

export default Idle;
